// extracted by mini-css-extract-plugin
export default {"row":"nhNeKFQ8L8etoTgJ34sp"};